import { configureStore } from "@reduxjs/toolkit";
import todoReducer from "../features/todo/TodoSlice";
import userReducer from "../features/user/UserSlice";

export const store = configureStore({
  reducer: {
    todo: todoReducer,
    user: userReducer,
  },
});
